import React, { useEffect } from "react";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import RoadMap from "../components/roadMap/RoadMap";
import WhoWeServe from "../components/who-we-serve/WhoWeServe";
import HighValues from "../components/high-values/HighValues";
import TypesOfBuild from "../components/types-of-build/TypesOfBuild";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import { IndustryTabsData } from "../data/industriesTabsData";
import DevelopmentServices from "../components/development-services/DevelopmentServices";
import ContactSection from "../components/contactSection/ContactSection";
import { WebServicesIndustryTabsItemsData } from "../data/web-app-service-page";
import NewEngagementModels from "../components/new-engagment-modal";
import {
  customSoftwareDevelopmentPageServices,
  faqData,
  HighvaluesData,
  mainBannerImg,
  schemaData,
  tabItems,
  tabs,
  TypesOfBuildData,
  WhoWeServeData,
  WhyChooseBitsclanData,
} from "../data/custom-development-data.js";
import { useTranslation } from "react-i18next";
import { bannerContent } from "../data/web-app-services-data.js";
import SimpleModels from "../components/simpleEngagementModels/index.jsx";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta.jsx";
import MegaMenu from "../components/MegaMenu/MegaMenu.jsx";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection.jsx";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner.jsx";
import TrustedPartner from "../components/trustedPartners/TrustedPartner.jsx";
import OurServices from "../components/our-services/OurServices.jsx";
import NewTestimonials from "../components/new-testimonials/NewTestimonials.jsx";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs.jsx";
import { AiMlPageData } from "../data/ai-ml-data.js";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange.jsx";

const MobileDevelopmentServices = () => {
  const { t } = useTranslation("customDevelopmentPage");
  const BannerContent = t("customDevPageBanner", { returnObjects: true });
  const DevelopmentServicesContent = t("customDevPageDevelopmentSerivces", {
    returnObjects: true,
  });
  const TypesOfBuildContent = t("customDevPageTypesOfBuild", {
    returnObjects: true,
  });
  const whoWeServeSectionContent = t("customDevPageWhoWeServeSection", {
    returnObjects: true,
  });
  const whyChoseBitsclanSection = t("customDevPageWhyChoseUsSection", {
    returnObjects: true,
  });
  const highValueSectionData = t("customDevPageHighValueSection", {
    returnObjects: true,
  });
  const roadMapSectionData = t("customDevPageRoadMapSection", {
    returnObjects: true,
  });
  const coverTheStackData = t("customDevPageCoverTheStack", {
    returnObjects: true,
  });
  const faqSection = t("customDevPageFaqSection", { returnObjects: true });
  const industriesHeading = t("customDevPageIndustryHeading", {
    returnObjects: true,
  });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("customSoftwareTitle", {
    returnObjects: false,
  });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Full-cycle Custom Software Development Services in USA | Bitsclan</title>
        <meta
          name="description"
          content="Need custom software development services that power your business? Bitsclan delivers custom CRM, ERP, SaaS, and enterprise-grade software solutions using AI, blockchain, and cloud technologies."
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading="Custom Software Development Services"
        mainHeading="Trusted by <span>Startups,</span> SMBs, & Enterprises Around the Globe"
        description="Let us take your eureka moment from a raw concept to feasibility assessment, & from design to development. Our custom software development services offer robust, secure, scalable solutions to ensure sustainable growth for your business."
      />
      <TrustedPartner />

      <OurServices
        buttonText="Start Your Journey"
        servicesCardsData={customSoftwareDevelopmentPageServices?.cardsData}
        shortHeading={customSoftwareDevelopmentPageServices?.shortHeading}
        mainHeading={customSoftwareDevelopmentPageServices?.mainHeading}
        description={customSoftwareDevelopmentPageServices?.description}
      />

      <NewTestimonials
        shortHeading="Our Testimonials"
        mainHeading="Voices of <span>Global</span> Enterprises on Our Custom Software Development Excellence"
        description="Discover why businesses trust Bitsclan for cutting-edge Custom Software Development solutions. Read real feedback from clients who achieved success with our services."
      />

      <WhyChooseUs
        heading="Advantage of Partnering With Us"
        greenHeading="The Strategic "
        shortHeading="why Choose Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
        stats={[
          // {
          //   number: "2017",
          //   title: "Delivering Excellence Since"
          // },
          {
            number: "120+",
            title: "Successful Projects Delivered"
          },
          {
            number: "100+",
            title: "Associated Professionals"
          },
        ]}
      />

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <SimpleModels content={engagementModelsContent} />

      <CoverTheStack
        whereStart={coverTheStackData?.CoverTheStackContent?.defaultTabOpen}
        mainHeading={coverTheStackData?.CoverTheStackContent?.mainHeading}
        subHeading={coverTheStackData?.CoverTheStackContent?.sectionDescripton}
        tabs={coverTheStackData?.tabs}
        tabItems={coverTheStackData?.tabItems}
      />

      {/* <DevelopmentServices
        tabs={DevelopmentServicesContent?.developmentServicesTabs}
        heading={
          DevelopmentServicesContent?.developmentServicesContent?.mainHeading
        }
        subheading={
          DevelopmentServicesContent?.developmentServicesContent
            ?.sectionDescripton
        }
      /> */}

      <TypesOfBuild
        typeOfApps={TypesOfBuildContent?.TypesOfBuildDataAccordian}
        heading={TypesOfBuildContent?.TypesOfBuildContent?.mainHeading}
        content={TypesOfBuildContent?.TypesOfBuildContent?.sectionDescripton}
        sideImage="web-app-development2.avif"
      />

      <WhoWeServe
        cardContent={whoWeServeSectionContent?.WhoWeServeCards}
        heading={whoWeServeSectionContent?.whoWeServeContent?.mainHeading}
        subHeading={
          whoWeServeSectionContent?.whoWeServeContent?.sectionDescripton
        }
      />

      <WhyChooseBitsclan
        tabs={whyChoseBitsclanSection?.whyChoseBitsclanTabs}
        heading={whyChoseBitsclanSection?.whyChoseBitsclanContent?.mainHeading}
        subheading={
          whyChoseBitsclanSection?.whyChoseBitsclanContent?.sectionDescripton
        }
      />

      <HighValues
        heading={highValueSectionData?.highValueContent?.mainHeading}
        subHeading={highValueSectionData?.highValueContent?.sectionDescripton}
        boxContent={highValueSectionData?.highvaluesDataCards}
        btnLink="#"
        btnText={highValueSectionData?.highValueContent?.buttonText}
      />

      {/* <NewEngagementModels /> */}


      <RoadMap
        heading={roadMapSectionData?.roadMapStepsContent?.mainHeading}
        roadMapHeading={roadMapSectionData?.roadMapStepsHeading}
        description={roadMapSectionData?.roadMapStepsContent?.sectionDescripton}
        roadMapsteps={roadMapSectionData?.roadMapStepsDescription}
      />

      {/* <IndustriesTabs mainheading={industriesHeading?.mainHeading} /> */}

      <PioneeringChange
        tabData={AiMlPageData.industries.tabData}
        // showIndustries={["Healthcare", "Fintech", "E-commerce & Retail", "Real Estate", "Automotive", "Education"]}
        shortHeading="Industries We Serve"
        greenHeading={industriesHeading?.mainHeading}
        // mainHeading={"Redefining Industries "}
        content={
          "Driving innovation & transforming industries with advanced Web Applications expertise & actionable insights."
        }
      />

      <DevelopingSolution
        heading="Developing Solutions That Transcend Mere Digital Transformation"
        subheading="We deliver innovative solutions that surpass digital transformation, driving impactful & lasting success."
      />

      <TrendsInsights
        specificClass="mobile-dev-page"
        category="custom-developmet"
      />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={faqSection?.questionAndAnswer}
        mainHeading={faqSection?.faqContent?.mainHeading}
        subHeading={faqSection?.faqContent?.sectionDescripton}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default MobileDevelopmentServices;
